






















import Component, { mixins } from "vue-class-component";
import BlockBase from "@/components/BlockBase.vue";
import { Prop } from "vue-property-decorator";
import { FormFields, FormValues } from "@/types";
import BlockBaseForm from "@/components/BlockBaseForm.vue";
import WithPaymentSystems from "@/mixins/WithPaymentSystems";
import { InputPaymentSystemCreate } from "@teacherskaya/api-provider/dist/api/PaymentSystemsProvider";
import BlockBaseView from "@/components/BlockBaseView.vue";
import ModalConfirm from "@/components/ModalConfirm.vue";
import PaymentSystemMixin from "../mixins/PaymentSystemMixin";
import PageTitle from "@/components/PageTitle.vue";
import { $t } from "@/lib/helpers/i18nHelper";
import BaseLabel from "@/components/BaseLabel.vue";
import FieldPrinter from "@/components/FieldPrinter/FieldPrinter";
import { Currency } from "@teacherskaya/api-provider/dist/api/CurrencyProvider";

@Component({
  name: "BlockPaymentSystemAdd",
  components: {
    PageTitle,
    BlockBaseView,
    BlockBaseForm,
    BlockBase,
    ModalConfirm,
    BaseLabel,
    FieldPrinter,
  },
})
export default class BlockPaymentSystemAdd extends mixins(WithPaymentSystems, PaymentSystemMixin) {
  @Prop({ required: true })
  public readonly type!: string;

  @Prop({ required: true })
  public readonly currencyList!: Currency[];

  get fields(): FormFields {
    return this.fieldsBuilder(this.type, false, 0, this.currencyList);
  }

  get title(): string {
    const info = this.getPaymentSystemInfo(this.type);
    return $t("Add {0}", [info.name]);
  }

  public save(values: FormValues, vm?: any) {
    const data: InputPaymentSystemCreate = {
      active: values.active ? values.active : false,
      type: this.type,
      details: this.getDetails(values),
      currencies: values.currencies,
    };
    this.paymentSystemsCreate({ data }).then(() => {
      this.$emit("added");
      if (vm) vm.values = {};
    });
  }

  public cancel() {
    this.$emit("cancel");
  }
}
